import { useCallback, useMemo } from 'react';
import { FetchResult, ApolloCache } from '@apollo/client';
import {
  GetSmartSuggestionSettingsDocument,
  PutSmartSuggestionSettingInput,
  PutSmartSuggestionSettingsMutation,
  usePutSmartSuggestionSettingsMutation
} from 'graphql/types';

export const usePutSmartSuggestionSettings = (): {
  putSmartSuggestionSettings: (
    input: PutSmartSuggestionSettingInput
  ) => Promise<
    FetchResult<
      PutSmartSuggestionSettingsMutation,
      Record<string, any>,
      Record<string, any>
    >
  >;
  loading: boolean;
} => {
  const [
    putSmartSuggestionMutation,
    { loading }
  ] = usePutSmartSuggestionSettingsMutation();

  const putSmartSuggestionSettings = useCallback(
    async (input: PutSmartSuggestionSettingInput) =>
      await putSmartSuggestionMutation({
        variables: {
          input
        },
        update(cache: ApolloCache<PutSmartSuggestionSettingsMutation>) {
          cache.writeQuery({
            query: GetSmartSuggestionSettingsDocument,
            data: {
              getSmartSuggestionSettings: {
                settings: input?.settings
              }
            }
          });
        }
      }),

    [putSmartSuggestionMutation]
  );

  return useMemo(
    () => ({
      putSmartSuggestionSettings,
      loading
    }),
    [putSmartSuggestionSettings, loading]
  );
};
